import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import { faSync, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { chartreuse, darkGrey2, white } from 'lib/css/colors';
import useProductScoreStyle from 'lib/hooks/product/useProductScoreStyle';

function ProductListScoreCard({ score, name, refetch, filePath }) {
  const { letter, backgroundStyle } = useProductScoreStyle(score);

  return (
    <div className={classNames('d-flex mx-2 p-2', css(styles.cardContainer, backgroundStyle))}>
      <div className={css(styles.letter)}>{letter}</div>
      <div className="d-flex flex-column">
        <span className={css(styles.percentage)}>{`${score}%`}</span>
        <span className={css(styles.name)}>{name}</span>
      </div>
      {refetch && (
        <OverlayTrigger overlay={<Tooltip>Refetch and calculate the data</Tooltip>}>
          <div className={css(styles.refetch)}>
            <FontAwesomeIcon icon={faSync} onClick={refetch} />
          </div>
        </OverlayTrigger>
      )}
      {filePath && (
        <OverlayTrigger overlay={<Tooltip>Download the data</Tooltip>}>
          <div className={classNames(css(styles.filePath), 'ml-2')}>
            <FontAwesomeIcon icon={faDownload} onClick={() => window.open(filePath, '_blank')} />
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: chartreuse,
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'space-around',
    maxWidth: '240px',
    minWidth: '240px',
  },
  imageIcon: {
    color: darkGrey2,
  },
  percentage: {
    color: white,
    fontWeight: 'bold',
    fontSize: '1.5rem',
  },
  letter: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: white,
  },
  name: {
    color: white,
    fontSize: '0.8rem',
  },
  refetch: {
    color: white,
    fontSize: '0.8rem',
    cursor: 'pointer',
  },
  filePath: {
    color: white,
    fontSize: '0.8rem',
    cursor: 'pointer',
  },
});

ProductListScoreCard.propTypes = {
  score: PropTypes.number,
  name: PropTypes.string,
  refetch: PropTypes.func,
  filePath: PropTypes.string,
};

export default ProductListScoreCard;
